// Hide the floating button when the footer enters the screen, so it never covers footer links.
(() => {
  const button = document.querySelector('.bb-wa-support');
  const footer = document.querySelector('.bb-footer');
  if (!button || !footer || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    button.classList.toggle('bb-wa-hidden', entries.some(entry => entry.isIntersecting));
  }, {threshold: 0});
  observer.observe(footer);
})();
